module.exports = __webpack_public_path__ + "img/pos-icon-active.d7c2245f.svg";